import { POIGalleryAgentSticky } from './poi-gallery-agent-sticky';

export default POIGalleryAgentSticky;
